import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/config/api'
import { axios } from '@/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query'
import { Dto } from '@/types'

const getUserProfile = (signal?: AbortSignal): Promise<Dto['UserDetailsDto']> => axios.get('/users/me', { signal })

type QueryFnType = typeof getUserProfile

type UseGetUserProfileOptions = {
  config?: QueryConfig<QueryFnType>
}

export const useGetUserProfile = ({ config }: UseGetUserProfileOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    retry: 2,
    refetchOnReconnect: true,
    ...config,
    queryKey: [QUERY_KEYS.getProfile],
    queryFn: ({ signal }) => getUserProfile(signal),
  })
}
